import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';

const MAX_PRODUCTS_TO_SHOW = 4;

@Component({
  standalone: true,
  selector: 'base-products-in-box',
  templateUrl: './products-in-box.component.html',
  styleUrls: ['./products-in-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule]
})
export class ProductsInBoxComponent {
  MAX_PRODUCTS_TO_SHOW = MAX_PRODUCTS_TO_SHOW;

  readonly productsInABox = input<string[]>([]);
  private _isExpanded = signal(false);

  // Computed signal for filtered products
  readonly filteredProducts = computed(() => {
    const products = this.productsInABox();
    return products.filter(product => product !== '');
  });

  readonly hasMoreItems = computed(() => {
    return this.filteredProducts().length > MAX_PRODUCTS_TO_SHOW;
  });

  readonly productsInABoxToShow = computed(() => {
    return this.filteredProducts()
      .slice(0, this._isExpanded() ? this.filteredProducts().length : MAX_PRODUCTS_TO_SHOW);
  });

  get isExpanded(): boolean {
    return this._isExpanded();
  }

  toggleViewMoreComments(): void {
    this._isExpanded.set(!this._isExpanded());
  }
}

